import React, { FC } from 'react';
import Modal from '@minecraft.modal';
import { useTranslation } from '@blocs.i18n';
import CreditCardForm from '../CreditCardForm';

type Props = {
  isOpen: boolean;
  handleToggleClick: () => void;
};

const AddCardModal: FC<Props> = ({ isOpen, handleToggleClick }) => {
  const { t } = useTranslation();

  return (
    isOpen && (
      <Modal
        isOpen
        handleToggleClick={handleToggleClick}
        modalSize="small"
        isFooterHidden
        title={t('common:paywall.addPaymentMethod.title')}
      >
        <CreditCardForm isUpdateBillingInfo isAddModal omitTitle />
      </Modal>
    )
  );
};

export default AddCardModal;
